// TODO: delete this and import from hcx-core
export const resolveUrl = (url: string, baseUrl: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }

  return url.startsWith('/') ? `${baseUrl}${url}` : `${baseUrl}/${url}`
}

export default resolveUrl
